import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

// Tracks the currently-selected record id per entity. Full-page detail screens
// read this to know which record to edit, since the app navigates by path only
// (no router / route params). `null` means "create new".
export type SelectionState = Record<string, string | null>;

const initialState: SelectionState = {};

const selectionSlice = createSlice({
  name: "selection",
  initialState,
  reducers: {
    setSelected(
      state,
      action: PayloadAction<{ entity: string; id: string | null }>,
    ) {
      state[action.payload.entity] = action.payload.id;
    },
    clearSelected(state, action: PayloadAction<string>) {
      delete state[action.payload];
    },
  },
});

export const { setSelected, clearSelected } = selectionSlice.actions;

export default selectionSlice.reducer;
